import script from "./GridReportsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridReportsComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridReportsComponent.vue?vue&type=style&index=0&id=27b40d48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b40d48"]])

export default __exports__